const MIME_EXTENSION_MAP = {
  "image/jpeg": ".jpg",
  "image/jpg": ".jpg",
  "image/png": ".png",
  "image/webp": ".webp",
  "image/gif": ".gif",
  "image/svg+xml": ".svg",
  "image/bmp": ".bmp",
  "image/tiff": ".tiff",
  "image/avif": ".avif",
  "image/heic": ".heic",
  "image/heif": ".heif",
  "application/pdf": ".pdf",
};

export function getExtensionFromMime(mimeType) {
  if (!mimeType || typeof mimeType !== "string") return "";
  const cleaned = mimeType.toLowerCase().split(";")[0].trim();
  if (MIME_EXTENSION_MAP[cleaned]) {
    return MIME_EXTENSION_MAP[cleaned];
  }
  if (cleaned.startsWith("image/")) {
    const sub = cleaned.slice(6).split("+")[0];
    if (sub && /^[a-z0-9]+$/.test(sub)) {
      return `.${sub}`;
    }
  }
  return "";
}

export function sanitizeFilename(filename) {
  if (!filename || typeof filename !== "string") return "";
  // Strip control characters (0x00-0x1F and 0x7F-0x9F) without triggering no-control-regex
  let cleaned = "";
  for (let i = 0; i < filename.length; i += 1) {
    const code = filename.charCodeAt(i);
    if ((code >= 0 && code <= 31) || (code >= 127 && code <= 159)) {
      continue;
    }
    cleaned += filename[i];
  }

  cleaned = cleaned
    .replace(/[/\\]+/g, "_")
    .replace(/[<>:"|?*]/g, "_")
    .trim()
    .replace(/\.+$/g, "")
    .trim();

  if (!cleaned || /^[._]+$/.test(cleaned)) {
    return "";
  }
  return cleaned;
}

export function getFilenameFromContentDisposition(value) {
  if (!value) return "";

  const str = String(value);

  // 1. filename*=UTF-8''... (RFC 5987 / RFC 6266)
  const utf8Match = str.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    const encodedName = utf8Match[1].trim().replace(/^['"]|['"]$/g, "");
    try {
      const decoded = decodeURIComponent(encodedName);
      if (decoded) return decoded;
    } catch {
      if (encodedName) return encodedName;
    }
  }

  // 2. filename="quoted" or filename=unquoted
  const quotedMatch = str.match(/filename\s*=\s*"([^"]+)"/i);
  if (quotedMatch?.[1]) {
    return quotedMatch[1].trim();
  }

  const unquotedMatch = str.match(/filename\s*=\s*([^;\s]+)/i);
  if (unquotedMatch?.[1]) {
    return unquotedMatch[1].trim();
  }

  return "";
}

export function resolveAttachmentFilename(
  contentDispositionOrHeaders,
  attachment = {},
  mimeFallback = ""
) {
  let headerValue = "";
  if (typeof contentDispositionOrHeaders === "string") {
    headerValue = contentDispositionOrHeaders;
  } else if (
    contentDispositionOrHeaders &&
    typeof contentDispositionOrHeaders.get === "function"
  ) {
    headerValue = contentDispositionOrHeaders.get("content-disposition") || "";
  } else if (contentDispositionOrHeaders?.["content-disposition"]) {
    headerValue = contentDispositionOrHeaders["content-disposition"];
  }

  const fromHeader = getFilenameFromContentDisposition(headerValue);
  const sanitizedHeader = sanitizeFilename(fromHeader);
  if (sanitizedHeader) {
    return sanitizedHeader;
  }

  const sanitizedOriginal = sanitizeFilename(attachment?.originalName);
  if (sanitizedOriginal) {
    return sanitizedOriginal;
  }

  const effectiveMime = (
    attachment?.mimeType ||
    mimeFallback ||
    ""
  ).toLowerCase().trim();

  const ext = getExtensionFromMime(effectiveMime);
  const baseId =
    attachment?.id !== undefined && attachment?.id !== null && attachment?.id !== ""
      ? `imagen-${attachment.id}`
      : "imagen";

  return ext ? `${baseId}${ext}` : baseId;
}

export function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = sanitizeFilename(fileName) || "descarga";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
}
